module.exports = __webpack_public_path__ + "img/9_Science_cover.461a9d5b.jpg";